export default __webpack_public_path__ + "static/media/DSC_0507.94589307.webp";